__turbopack_context__.v({
  "animationInitialState": "backgroundMap-module-scss-module__s_DZ8a__animationInitialState",
  "cityContainer": "backgroundMap-module-scss-module__s_DZ8a__cityContainer",
  "cityIndicator": "backgroundMap-module-scss-module__s_DZ8a__cityIndicator",
  "hongKong": "backgroundMap-module-scss-module__s_DZ8a__hongKong",
  "kyiv": "backgroundMap-module-scss-module__s_DZ8a__kyiv",
  "london": "backgroundMap-module-scss-module__s_DZ8a__london",
  "mapContainer": "backgroundMap-module-scss-module__s_DZ8a__mapContainer",
  "mapImage": "backgroundMap-module-scss-module__s_DZ8a__mapImage",
  "miami": "backgroundMap-module-scss-module__s_DZ8a__miami",
  "newYork": "backgroundMap-module-scss-module__s_DZ8a__newYork",
  "radar": "backgroundMap-module-scss-module__s_DZ8a__radar",
  "radarBigCircle": "backgroundMap-module-scss-module__s_DZ8a__radarBigCircle",
  "radarSmallCircle": "backgroundMap-module-scss-module__s_DZ8a__radarSmallCircle",
  "singapore": "backgroundMap-module-scss-module__s_DZ8a__singapore",
  "smallRadar": "backgroundMap-module-scss-module__s_DZ8a__smallRadar",
  "wrapper": "backgroundMap-module-scss-module__s_DZ8a__wrapper",
});
